import { isVideo } from "fleet/view/media-library/utils";
import PropTypes from "prop-types";
import React from "react";
import {
  Button,
  Col,
  FormLabel,
  FormControl,
  FormGroup,
  InputGroup,
  Row,
} from "react-bootstrap";

class MediaUploadFileForm extends React.Component {
  static get displayName() {
    return "MediaUploadFileForm";
  }

  static get propTypes() {
    return {
      file: PropTypes.shape({
        duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        fname: PropTypes.string,
        name: PropTypes.string,
        rawFile: PropTypes.object,
      }),
      disabled: PropTypes.bool,
      onRemove: PropTypes.func,
      onUpdate: PropTypes.func,
      onUpload: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      disabled: false,
      onRemove: () => {},
      onUpdate: () => {},
      onUpload: () => {},
    };
  }

  constructor(props) {
    super(props);

    this._onRemove = this._onRemove.bind(this);
    this._onUpload = this._onUpload.bind(this);
    this._onUpdateName = this._onUpdate.bind(this, "name");
    this._onUpdateDuration = this._onUpdate.bind(this, "duration");
  }

  _onRemove() {
    const { onRemove, file } = this.props;
    onRemove(file.fname);
  }

  _onUpdate(field, e) {
    const { value } = e.currentTarget;
    const { onUpdate, file } = this.props;
    onUpdate(file, field, value);
  }

  _onUpload() {
    const { onUpload, file } = this.props;
    onUpload(file);
  }

  render() {
    const { disabled, file } = this.props;
    const { fname, name, duration } = file;
    const isVideoFile = isVideo(file.rawFile.type);

    return (
      <Row className="content-upload-form-file">
        <Col xs={1} className="pd-top">
          <Button
            className="btn btn-outline btn-delete-content"
            disabled={disabled}
            onClick={this._onRemove}
          >
            <i className="fa fa-times" />
          </Button>
        </Col>
        <Col xs={3} className="pd-top">
          {fname}
        </Col>
        <Col xs={4}>
          <FormGroup controlId="name">
            <FormLabel>Content Name</FormLabel>
            <FormControl
              key="name"
              disabled={disabled}
              name="name"
              onChange={this._onUpdateName}
              type="text"
              value={name}
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          {isVideoFile ? (
            <div className="clearfix d-block d-sm-none" />
          ) : (
            <FormGroup controlId="duration">
              <FormLabel>Duration</FormLabel>
              <InputGroup>
                <FormControl
                  key="duration"
                  className="form-control content-upload-form-duration"
                  disabled={disabled}
                  onChange={this._onUpdateDuration}
                  name="duration"
                  value={duration}
                  type="text"
                />
                <InputGroup.Append>
                  <InputGroup.Text>seconds</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
            </FormGroup>
          )}
        </Col>
        <Col xs={2} className="pd-top">
          <Button
            className="btn btn-outline btn-upload-content"
            disabled={disabled}
            onClick={this._onUpload}
          >
            Add
          </Button>
        </Col>
      </Row>
    );
  }
}

export { MediaUploadFileForm };
